import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button, ButtonPropsType } from 'components/Controls/Button';
import EyeOffSvg from './eyeOff.svg';

interface IconButtonPropsType extends ButtonPropsType {
  iconSize?: number;
}

export const EyeOffIcon = (props: any) => <Icon component={EyeOffSvg} {...props} />;

export const EyeOffIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonPropsType>(
  ({ size = 'medium', iconSize = 24, type = ButtonType.OutlineIcon, ...props }, ref) => (
    <Button
      ref={ref}
      type={type}
      icon={<EyeOffSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
EyeOffIconButton.displayName = 'EyeOffIconButton';
